<template>
  <div id="siffaApp">
    <component :is="layout">
      <router-view />
    </component>
    <el-dialog
      :visible.sync="showDialog"
      width="440px"
      class="login_dialog"
      :append-to-body="true"
      @close="showDialog = false"
    >
      <loginDialog @loginSuccess="loginSuccess"></loginDialog>
    </el-dialog>
  </div>
</template>
<script>
import defaultlayout from "./layouts/default.vue";
import signlayout from "./layouts/sign.vue";
import loginDialog from "~gbk/components/common/loginDialog";
import baseConsolelayout from "~bac/layouts/default.vue";
import emptylayout from "./layouts/empty";
export default {
  components: {
    defaultlayout,
    signlayout,
    loginDialog,
    baseConsolelayout,
    emptylayout
  },
  data() {
    return {
      default_layout: "default", //设置layout
      showDialog: false,
    };
  },
  mounted() {
    this.$GLOBALEVENT.$on("SHOWGLOBALLOGIN", (e) => {
      if (e) {
        this.eventCallback = e.waitTodo;
      }
      this.showDialog = true;
    });
    this.$GLOBALEVENT.$on("CLOSEGLOBALLOGIN", (e) => {
      this.showDialog = false;
    });
  },
  methods: {
    loginSuccess() {
      this.showDialog = false;
      if (this.eventCallback) {
        this.$nextTick(() => {
          this.eventCallback && this.eventCallback();
        });
      }
    },
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || this.default_layout) + "layout";
    },
  },
};
</script>
<style>
</style>
